import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import AppShell from "@/components/AppShell";
import { PageContainer, PageHeader, EmptyState } from "@/components/Page";
import { StatusBadge, CategoryBadge } from "@/components/Badges";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Link, useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";

export default function ResidentTickets() {
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/tickets"); setTickets(data); }
      catch (e) { toast.error(formatApiError(e)); }
    })();
  }, []);
  return (
    <AppShell>
      <PageContainer>
        <PageHeader
          eyebrow="Resident"
          title="My Tickets"
          description="Every issue you've reported."
          actions={
            <Button onClick={() => navigate("/r/tickets/new")} data-testid="new-ticket-btn" className="rounded-none bg-black hover:bg-zinc-800 h-10 px-4 uppercase tracking-wider text-xs font-semibold">
              <Plus className="h-4 w-4" /> New Ticket
            </Button>
          }
        />
        {tickets.length === 0 ? (
          <EmptyState title="No tickets yet" description="You haven't raised any tickets." />
        ) : (
          <div className="bg-white border border-zinc-200 overflow-x-auto">
            <table className="w-full text-sm min-w-[640px]">
              <thead className="border-b border-zinc-200 bg-zinc-50">
                <tr className="text-left">
                  <th className="p-4 label-eyebrow font-semibold">Title</th>
                  <th className="p-4 label-eyebrow font-semibold">Category</th>
                  <th className="p-4 label-eyebrow font-semibold">Status</th>
                  <th className="p-4 label-eyebrow font-semibold">Created</th>
                </tr>
              </thead>
              <tbody>
                {tickets.map((t) => (
                  <tr key={t.id} className="border-b border-zinc-100 hover:bg-zinc-50" data-testid={`ticket-row-${t.id}`}>
                    <td className="p-4"><Link to={`/tickets/${t.id}`} className="font-semibold hover:underline underline-offset-4">{t.title}</Link></td>
                    <td className="p-4"><CategoryBadge category={t.category} /></td>
                    <td className="p-4"><StatusBadge status={t.status} /></td>
                    <td className="p-4 text-zinc-500 text-xs">{new Date(t.created_at).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </PageContainer>
    </AppShell>
  );
}
